import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .header-phone-link': {
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.surface.pricing,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'F37SonicTrial-Medium !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      /* Padding (not margin) so the hero background/image covers the offset below the fixed header */
      marginTop: 0,
      '& .hero-home-button': {
        background: `${palette.secondary.light} !important`,
      },
      background: `
          url('/images/hero-other.webp')
          no-repeat center center
        `,
      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.primary,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    /* Use padding (not margin) so brand background fills the top offset under the header */
    '& .home-hero-variant-2': {
      marginTop: 0,
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.brandLight,
      /* iPad / small desktop: stack like tab — copy on top, image below (no MFE change) */
      '@media(max-width: 1200px) and (min-width: 900px)': {
        maxHeight: 'none !important',
        display: 'flex',
        flexDirection: 'column-reverse',
        '& .hero-background': {
          position: 'static !important',
          width: '100% !important',
          maxWidth: '100% !important',
          height: 'auto !important',
          objectFit: 'cover',
          objectPosition: 'center center',
        },
        '& .hero-section': {
          maxHeight: 'none !important',
          '& .MuiGrid-item': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
          },
        },
      },
      '@media(max-width: 600px)': {
        backgroundColor: palette.background.brandLight,
        paddingTop: '40px !important',
        /* Tablet rule is 600–1200px only; on phones SectionHeader still uses align=left for overline flex — force center */
        '& .hero-section': {
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
          },
        },
      },
      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.background.brandLight,
        /* HeroVariant2 switches src at MUI md (960px); keep mobile art through 1024px without MFE changes */
        '@media (max-width: 1024px)': {
          content:
            "url('/images/home-images/home-banner-img-mobile.webp')",
        },
        '@media screen and (max-width: 600px)': {
          height: '440px',
          /* HeroVariant2 defaults to object-position: right; center crop on mobile */
          objectPosition: 'center center !important',
        },
        '@media(max-width: 1200px) and (min-width: 600px)': {
          objectFit: 'cover',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-alternate__content': {
          backgroundColor: palette.background.brandLight,
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
            '@media(min-width: 600px) and (max-width: 1200px)': {
              padding: '0 !important',
            },
            '@media(max-width: 600px)': {
              padding: '0px 40px !important',
            },
          },
        },
        '& .section-header': {
          '& .section-header__cta-container': {
            '@media(max-width: 900px)': {
              justifyContent: 'center !important',
            },
          },
        },
        /* Offset was on .section-header marginTop; with pre-logo + SectionHeader as siblings, that created a large gap. Apply offset once on the stack instead. */
        '& .home-hero-pretitle-stack': {
          justifyContent: 'flex-start',
          height: 'fit-content',
          /* MFE centers the stack below theme `lg` (1200 here); product wants logo left whenever width > 1024, centered at 1024 and below. */
          '@media (min-width: 1025px)': {
            alignItems: 'flex-start !important',
          },
          '@media screen and (min-width: 768px)': {
            paddingTop: '60px',
          },
        },
        /* Hero pretitle — Figma Web: 20px bold #0e0e0e, lh 1.2; tablet/mob scaled + centered when hero stacks */
        '& .section-header__overline-wrapper.home-hero-pretitle': {
          fontFamily: 'F37SonicTrial-Medium, sans-serif',
          fontWeight: 700,
          fontSize: '20px',
          lineHeight: 1.2,
          color: '#0e0e0e',
          textAlign: 'left',
          letterSpacing: '-0.4px',
          marginBottom: '16px',
          '@media (max-width: 1200px) and (min-width: 601px)': {
            fontSize: '18px',
            lineHeight: 1.2,
            textAlign: 'center',
            marginBottom: '12px',
          },
          '@media (max-width: 600px)': {
            fontSize: '16px',
            lineHeight: 1.25,
            textAlign: 'center',
            marginBottom: '12px',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'F37SonicTrial-Medium',
        fontWeight: 500,
        maxWidth: 634,
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
        },
        '@media(max-width: 600px)': {
          lineHeight: '44px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'center !important',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
        fontFamily: 'PlusJakartaSans-Regular',
        fontWeight: 400,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        '@media(max-width: 600px)': {
          textAlign: 'center !important',
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'PlusJakartaSans-Regular',
          maxWidth: 550,
        },
      },
      /* HeroVariant2 uses align="left" on md+; center copy + CTAs (same band as .hero-background) */
      '@media(max-width: 1200px) and (min-width: 600px)': {
        '& .hero-section': {
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
          },
          '& .section-header__title': {
            textAlign: 'center !important',
          },
          '& .section-header__subtitle': {
            textAlign: 'center !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
          },
          '& .section-header__cta-wrapper': {
            margin: 'auto',
          },
        },
        '& .home-hero-title': {
          textAlign: 'center !important',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        '& .home-hero-subtitle': {
          textAlign: 'center !important',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.main,
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '10px !important',
          paddingTop: '10px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-service-tile': {
        borderBottom: `0.5px solid ${palette.background.border} !important`,
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'PlusJakartaSans-Regular !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
        textAlign: 'left !important',
        paddingBottom: '10px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '30px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: palette.text.tertiaryLight,
        textAlign: 'left !important',
        letterSpacing: '-0.32px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.68px !important',
        paddingBottom: '24px !important',
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat, no-repeat',
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '48px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px) and (min-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'PlusJakartaSans-Regular !important',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.primary.light,
            color: palette.text.tertiary,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'F37SonicTrial-Medium !important',
            fontSize: '32px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: palette.text.tertiary,
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '32px !important',
            fontFamily: 'F37SonicTrial-Medium !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 700px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          fontFamily: 'F37SonicTrial-Medium !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'PlusJakartaSans-Regular !important',
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
        },
        '& .savings-summary-link': {
          color: `${palette.secondary.main} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '@media(min-width: 601px) and (max-width: 1200px)': {
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100% !important',
          },
          '& .react-multi-carousel-item': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          },
          '& .carousel-single-item.MuiGrid-container': {
            justifyContent: 'flex-start !important',
            width: '100% !important',
          },
          '& .carousel-single-item > .MuiGrid-item': {
            maxWidth: '100% !important',
            width: '100% !important',
            flexBasis: '100% !important',
          },
          '& .planCard': {
            width: '100% !important',
            maxWidth: '100% !important',
            boxSizing: 'border-box',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.fill,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100% !important',
        maxWidth: '100%',
        margin: 0,
        overflow: 'hidden',
        position: 'relative',
        height: 'auto',
        minHeight: 'unset',
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          maxWidth: '100% !important',
          maxHeight: '460px',
          height: 'auto !important',
          minHeight: 'unset !important',
          objectFit: 'contain !important',
          display: 'block !important',
          position: 'relative',
          top: 'auto',
          left: 'auto',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'F37SonicTrial-Medium !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 500,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.tableHead,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 500,
          fontFamily: 'F37SonicTrial-Medium !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiaryLight,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          '@media(max-width: 1200px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      /* Tab view: HowItWorks3 uses align left below md; match .section padding band (600–1024) */
      '@media(min-width: 600px) and (max-width: 1024px)': {
        '& .howitworks-title': {
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
          },
          '& .section-header__title': {
            textAlign: 'center !important',
          },
          '& .section-header__subtitle': {
            textAlign: 'center !important',
          },
        },
        '& .working-steps-container': {
          marginLeft: 'auto',
          marginRight: 'auto',
          '& .step-title': {
            textAlign: 'center !important',
          },
          '& .step-content': {
            textAlign: 'center !important',
          },
        },
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `
          url('/images/hero-other.webp')
          no-repeat center center
        `,
        backgroundSize: 'cover',
        '& .header-container': {
          margin: '0',
          '& .hero-link-button': {
            background: `${palette.primary.main} !important`,
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.highlight} !important`,
            boxShadow: 'none',
            '&:hover': {
              background: `${palette.primary.main} !important`,
              backgroundColor: `${palette.primary.main} !important`,
              color: `${palette.text.highlight} !important`,
            },
          },
          '& .hero-home-button': {
            background: `${palette.background.main} !important`,
            backgroundColor: `${palette.background.main} !important`,
            color: `${palette.secondary.main} !important`,
            border: `1px solid ${palette.secondary.main} !important`,
            '&:hover': {
              background: `${palette.background.main} !important`,
              backgroundColor: `${palette.background.main} !important`,
              color: `${palette.secondary.main} !important`,
              borderColor: `${palette.secondary.main} !important`,
            },
          },
        },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'F37SonicTrial-Medium !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'PlusJakartaSans-Regular !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.offer} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '40px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingInline: '90px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.background.hero1} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 1200px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button': {
          backgroundColor: palette.text.highlight,
        },
        display: 'flex !important',
        '@media(max-width: 900px)': {
          justifyContent: 'center !important',
        },
        '@media(min-width: 900px) and (max-width: 1200px)': {
          justifyContent: 'center !important',
        },
        '@media(min-width: 1200px)': {
          justifyContent: 'right !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        '& .hero-static-section-grid': {
          justifyContent: 'center !important',
        },
        '& .section-header__title': {
          textAlign: 'center !important',
        },
        '& .section-header__subtitle': {
          textAlign: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'PlusJakartaSans-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
      /* Find provider & choose plan — Back to Home same as FAQ / find-provider (outlined secondary on white) */
      '& .find-provider-section, & .plan-selection-section': {
        '& .header-container': {
          margin: '0',
          '& .hero-home-button': {
            background: `${palette.background.main} !important`,
            backgroundColor: `${palette.background.main} !important`,
            color: `${palette.secondary.main} !important`,
            border: `1px solid ${palette.secondary.main} !important`,
            '&:hover': {
              background: `${palette.background.main} !important`,
              backgroundColor: `${palette.background.main} !important`,
              color: `${palette.secondary.main} !important`,
              borderColor: `${palette.secondary.main} !important`,
            },
          },
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ — hero CTAs match landing: contained primary (Get Started) + outlined secondary (Back to Home / login) */
    '& .faq-hero-section': {
      '& .hero-header-title': {
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'PlusJakartaSans-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
        '& .hero-link-button': {
          background: `${palette.primary.main} !important`,
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          boxShadow: 'none',
          '&:hover': {
            background: `${palette.primary.main} !important`,
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.highlight} !important`,
          },
        },
        '& .hero-home-button': {
          background: `${palette.background.main} !important`,
          backgroundColor: `${palette.background.main} !important`,
          color: `${palette.secondary.main} !important`,
          border: `1px solid ${palette.secondary.main} !important`,
          '&:hover': {
            background: `${palette.background.main} !important`,
            backgroundColor: `${palette.background.main} !important`,
            color: `${palette.secondary.main} !important`,
            borderColor: `${palette.secondary.main} !important`,
          },
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .faq-get-started.MuiButton-containedPrimary': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: `${palette.primary.main} !important`,
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '& [data-testid="go-to-home-button"]': {
        background: `${palette.background.main} !important`,
        backgroundColor: `${palette.background.main} !important`,
        color: `${palette.secondary.main} !important`,
        border: `1px solid ${palette.secondary.main} !important`,
        '&:hover': {
          background: `${palette.background.main} !important`,
          backgroundColor: `${palette.background.main} !important`,
          color: `${palette.secondary.main} !important`,
          borderColor: `${palette.secondary.main} !important`,
        },
      },
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'F37SonicTrial-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'PlusJakartaSans-Regular !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'F37SonicTrial-Medium !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'F37SonicTrial-Medium',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 0,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: `${palette.text.highlight} !important`,
      '& a': {
        color: `${palette.text.highlight} !important`,
      },
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
  '.drawer-title-container': {
    backgroundColor: `${palette.secondary.main} !important`,
    color: `${palette.text.highlight} !important`,
  },

  /*
   * Payment drawer portals to body. `section.checkout_stripe_payment` is the whole scroll area
   * (Stripe + billing + order summary), not a "payment card only" wrapper — keep it white like the reference UI.
   */
  '.custom-drawer-wrapper section.checkout_stripe_payment': {
    backgroundColor: `${palette.background.default} !important`,
  },
};
